export default __webpack_public_path__ + "static/media/loading.770c3190.gif";